declare global {
    interface Window {
        Razorpay: any;
    }
}

export const openSubscriptionCheckout = ( checkout: any ) => {
    return new Promise((resolve, reject) => {
        const razorpay = new window.Razorpay({
            key: checkout.key,
            subscription_id: checkout.subscriptionId,
            name: checkout.planName,
            description: "Studio Subscription",
            handler: (response: any) => {
                resolve(response);
            },
            modal: {
                ondismiss: () => {
                    reject( new Error( "Payment cancelled"));
                },
            },
            theme: {
                color: "#4F46E5",
            },
        });
        razorpay.open();
    });
};